import styled, { css } from "styled-components";

const h1 = styled.h1`
  color: ${(props) => props.theme.color.main.font};
  font-size: 54px;
  font-weight: bold;
  user-select: none;

  i {
    font-style: italic;
  }
  b,
  strong {
    font-weight: bold;
  }
  /* MEDIA QUERIES */
  @media only screen and (max-width: 1450px) {
    font-size: 50px;
  }

  @media only screen and (max-width: 1024px) {
    font-size: 48px;
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    font-size: 40px;
  }
`;

const h2 = styled.h2`
  color: ${(props) => props.theme.color.main.font};
  font-size: 46px;
  line-height: 58px;
  font-weight: bold;
  user-select: none;
  b,
  strong {
    color: ${(props) => props.theme.color.main.font};
    font-weight: bold;
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 1450px) {
    font-size: 42px;
    line-height: 52px;
  }

  @media only screen and (max-width: 1024px) {
    font-size: 40px;
    line-height: 50px;
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    font-size: 28px;
    line-height: 30px;
  }
`;

const h3 = styled.h3`
  color: ${(props) => props.theme.color.main.font};
  font-size: 38px;
  line-height: 48px;
  user-select: none;

  b,
  strong {
    font-weight: bold;
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 1450px) {
    font-size: 34px;
  }

  @media only screen and (max-width: 1024px) {
    font-size: 32px;
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    font-size: 24px;
    line-height: 28px;
  }
`;

const h4 = styled.h4`
  color: ${(props) => props.theme.color.main.font};
  font-size: 20px;
  line-height: 27px;
  user-select: none;

  b,
  strong {
    font-weight: bold;
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 1450px) {
    font-size: 18px;
    line-height: 25px;
  }

  @media only screen and (max-width: 1024px) {
    font-size: 16px;
    line-height: 23px;
  }
`;

const h5 = styled.h5`
  color: ${(props) => props.theme.color.main.font};
  font-size: 20px;
  line-height: 25px;
  text-transform: uppercase;
  user-select: none;

  &.semiBold {
    font-weight: 600;
  }

  b,
  strong,
  &.bold {
    font-weight: bold;
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 1450px) {
    font-size: 18px;
  }

  @media only screen and (max-width: 1024px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const p = styled.p`
  font-size: 18px;
  line-height: 22px;
  user-select: none;

  i {
    font-style: italic;
  }
  b,
  strong {
    font-weight: bold;
  }
  em {
    font-weight: bold;
    text-transform: uppercase;
  }

  &.semiBold {
    font-weight: 600;
  }

  &.medium {
    font-weight: 500;
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 1450px) {
    font-size: 14px;
    line-height: 17px;
  }

  @media only screen and (max-width: 1024px) {
    font-size: 12px;
    line-height: 15px;
  }
`;

const Type = {
  h1,
  h2,
  h3,
  h4,
  h5,
  p,
};

export default Type;

/*
Doc
import Type from './Global/Typography.js';

H1
<Type.h1>Teste <b>Teste Bold</b></Type.h1>

H2
<Type.h2>Teste <b>Teste Bold</b></Type.h2>

H3
<Type.h3>Teste <b>Teste Bold</b></Type.h3>

H4
<Type.h4>Teste <b>Teste Bold</b></Type.h4>

H5
<Type.h5>Teste <b>Teste Bold</b></Type.h5>

H6
<Type.h5>Teste <b>Teste Bold</b> <i>Teste Itálico</i> <i><b>Teste Itálico Bold</b></i></Type.h5>

P
<Type.p>Teste <b>Teste Bold</b> <i>Teste Itálico</i> <i><b>Teste Itálico Bold</b></i> <em>Teste EM</em></Type.p>

*/
